var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkPaymentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_283_26305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5898 83.4508L46.2292 101.812C46.2292 101.812 46.2292 101.812 46.2288 101.812C46.2288 101.812 46.2288 101.813 46.2284 101.813C38.6357 109.406 26.2808 109.406 18.6873 101.813C15.0087 98.134 12.9833 93.2432 12.9833 88.0417C12.9833 82.8406 15.0087 77.9506 18.686 74.272C18.6864 74.2716 18.6869 74.2711 18.6873 74.2707L37.0479 55.9097C39.5827 53.3745 39.5827 49.264 37.0474 46.7292C34.5127 44.1944 30.4022 44.1944 27.8669 46.7292L9.50638 65.0902C9.50508 65.0915 9.50378 65.0932 9.50249 65.0945C3.3748 71.2244 0 79.374 0 88.0417C0 96.7115 3.37609 104.862 9.50681 110.993C15.8349 117.321 24.1464 120.485 32.4583 120.485C40.7702 120.485 49.0821 117.321 55.4093 110.993C55.4097 110.993 55.4097 110.992 55.4097 110.992L73.7703 92.6313C76.3051 90.0965 76.3051 85.986 73.7699 83.4508C71.2355 80.916 67.1255 80.916 64.5898 83.4508Z",
    fill: "url(#paint0_linear_283_26305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.997 32.9584C119.997 24.2886 116.62 16.1376 110.49 10.0069C97.8338 -2.64835 77.2418 -2.64792 64.587 10.0069C64.5866 10.0078 64.5857 10.0082 64.5853 10.0091L46.2251 28.3688C43.6899 30.9036 43.6899 35.0145 46.2251 37.5493C47.4932 38.8173 49.1542 39.4509 50.8156 39.4509C52.4766 39.4509 54.1385 38.8169 55.4056 37.5493L73.7658 19.1896C73.7662 19.1887 73.7671 19.1883 73.7679 19.1874C81.3606 11.5948 93.7155 11.5943 101.309 19.1874C104.987 22.866 107.013 27.7568 107.013 32.9584C107.013 38.1595 104.988 43.0495 101.31 46.7281L101.309 46.7294L82.9484 65.0904C80.4137 67.6251 80.4137 71.7356 82.9489 74.2709C84.2165 75.5385 85.8779 76.1725 87.5389 76.1725C89.2003 76.1725 90.8618 75.5385 92.1294 74.2709L110.49 55.9099C110.491 55.9086 110.493 55.9068 110.494 55.9055C116.622 49.7757 119.997 41.626 119.997 32.9584Z",
    fill: "url(#paint1_linear_283_26305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0367 83.4501C38.3043 84.7177 39.9657 85.3517 41.6267 85.3517C43.2881 85.3517 44.9496 84.7177 46.2172 83.4501L82.9392 46.7281C85.4744 44.1933 85.4744 40.0828 82.9392 37.5476C80.4044 35.0128 76.2939 35.0128 73.7587 37.5476L37.0367 74.2691C34.5015 76.8048 34.5015 80.9153 37.0367 83.4501Z",
    fill: "url(#paint2_linear_283_26305)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_283_26305",
    x1: 37.8357,
    y1: 44.8281,
    x2: 37.8357,
    y2: 120.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#770EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF30D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_283_26305",
    x1: 82.1602,
    y1: 0.515625,
    x2: 82.1602,
    y2: 76.1725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#770EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF30D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_283_26305",
    x1: 59.9879,
    y1: 35.6465,
    x2: 59.9879,
    y2: 85.3517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#770EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF30D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_26305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkPaymentIcon);
export default __webpack_public_path__ + "static/media/link-payment-icon.5e8351302fe0391007d0e70dea8ca110.svg";
export { ForwardRef as ReactComponent };